<div class="card mb-3" *ngIf="showAsCard" [class.cursor-not-allowed]="disabled">
  <div class="card-header">
    {{ 'components.delete_card.title' | translate }}
  </div>

  <div class="card-body">
    <button type="button" (click)="triggerDelete()" class="btn btn-danger w-100" [disabled]="disabled">
      {{ 'components.delete_card.button' | translate: {item: itemName} }}
    </button>
  </div>
</div>

<button type="button" *ngIf="!showAsCard" (click)="triggerDelete()" class="btn btn-danger w-100" [class.cursor-not-allowed]="disabled">
  {{ 'components.delete_card.button' | translate: {item: itemName} }}
</button>

<ng-template #confirmModal>
  <div class="modal-body text-center">
    <p>{{ 'components.delete_card.confirm_modal.title' | translate }}</p>
    <button type="button" class="btn btn-outline-danger me-3" (click)="confirmDelete()" >
      {{ 'components.delete_card.confirm_modal.confirm' | translate }}
    </button>
    <button type="button" class="btn btn-secondary ms-3" (click)="confirmModalRef?.hide()" >
      {{ 'components.delete_card.confirm_modal.cancel' | translate }}
    </button>
  </div>
</ng-template>
